// Feature callouts are printed directly in the folio image; the component
// renders that image without overlaying duplicate text labels.
export const Rem7FeatureRing = () => (
  <div className="w-full">
    <div className="relative mx-auto w-full lg:max-w-[620px]">
      <img
        src="/assets/rem7-folio-features.jpg"
        alt="REM7 smart toilet with its features labelled: proximity open/close, heated seat, instant warm water, remote and side controls, smart adjustable wash, bidet rear cleanse, warm-air drying, self-cleaning nozzle and night light"
        className="w-full rounded-md border border-accent/30 object-contain shadow-elegant"
        loading="eager"
        width={1152}
        height={864}
      />
    </div>
  </div>
);

export default Rem7FeatureRing;
